import api from "./axios";
import type { AuthUser, ApiMessage } from "@/types";

export const getGoogleAuthUrl = () =>
  `${process.env.API_URL || ""}/api/auth/google`;

export const logout = () =>
  api.post<ApiMessage>("/auth/logout").then((r) => r.data);

export const getMe = () => api.get<AuthUser>("/auth/me").then((r) => r.data);

export const deleteMyAccount = () =>
  api.delete<ApiMessage>("/auth/me").then((r) => r.data);
